import {useMutation} from '@tanstack/react-query';
import {apiClient, queryClient} from '@common/http/query-client';
import {toast} from '@ui/toast/toast';
import {DatatableDataQueryKey} from '@common/datatable/requests/paginated-resources';
import {showHttpErrorToast} from '@common/http/show-http-error-toast';
import {AxiosResponse} from 'axios';
import {Lien} from '@app/titles/models/lien';
import {useParams} from 'react-router-dom';

export interface UpdateLienPayload {
  id: number;
  qualite?: number;
  langues?: object;
  subs?: object;
  lien?: string;
  full_saison?: number;
  saison?: number;
  episode?: number;
  nfo?: string;
}

interface UpdateLienResponse {
  lien: Lien;
}

export function useUpdateLien() {
  const {lienId, nzbId, torrentId} = useParams();
  const id = lienId ?? nzbId ?? torrentId;
  const endpoint = lienId ? 'liens' : nzbId ? 'nzb' : 'torrents';
  return useMutation({
    mutationFn: (payload: UpdateLienPayload) =>
      updateLien(payload, endpoint, id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: DatatableDataQueryKey(endpoint),
      });
      toast('Link updated successfully');
    },
    onError: error => showHttpErrorToast(error),
  });
}

function updateLien(
  lien: UpdateLienPayload,
  endpoint: string,
  id?: number | string,
): Promise<AxiosResponse<UpdateLienResponse>> {
  return apiClient.put<UpdateLienResponse>(`${endpoint}/${id}`, {
    ...lien,
  });
}
